<div layout-vertical>
  <div layout-vertical padding-bottom-medium>
    <ng-content select="[header]"></ng-content>
  </div>

  @for (role of roles; track roleTrackBy($index, role)) {
    <div layout-vertical>
      <rt-divider variant="line"></rt-divider>
      <div layout-horizontal layout-space-between padding-tb-medium>
        <div>{{ role.name }}</div>
        <div layout-horizontal>
          @for (ability of abilities; track abilityTrackBy(i, ability); let i = $index) {
            <rt-checkbox
              [checked]="roleAbilityChecked(role, ability)"
              [disabled]="disabled"
              (valueChange)="setRoleAbility(role, ability, $any($event))"
              margin-left-medium
            >
              {{ ability.label }}
            </rt-checkbox>
          }
        </div>
      </div>
    </div>
  }
</div>
